<template>
  <aFormItem class="hf-wrapper hf-input-wrapper">
    <label v-if="label">{{ label }}</label>
    <div class="description" v-if="description">{{ description }}</div>
    <aInput
      class="hf-input"
      :type="type"
      :class="fieldClass"
      :placeholder="placeholder || 'Insira'"
      :v-currency="vCurrency"
      v-decorator="[
        fieldKey,
        {
          initialValue,
          rules: validationRules,
        },
      ]"
      :min="min"
      :max="max"
    >
      <template v-if="hasPrefixContent" #prefix>
        <slot v-if="!preIcon" name="prefix"></slot>
        <a-icon v-if="preIcon" type="field-svg" />
      </template>
      <template v-if="hasSuffixContent" #suffix>
        <slot name="suffix"></slot>
      </template>
    </aInput>
  </aFormItem>
</template>

<script>
export default {
  name: "HayaValueField",
  inheritAttrs: false,
  props: {
    label: String,
    type: String,
    description: String,
    fieldKey: String,
    placeholder: String,
    fieldClass: String,
    requiredMessage: String,
    required: Boolean,
    initialValue: String,
    min: Number,
    max: Number,
    list: Array,
    form: Object,
    readonly: Boolean,
    preIcon: Boolean,
    vCurrency: Object,
  },
  data() {
    return {
      validationRules: [],
    };
  },
  computed: {
    hasSuffixContent() {
      // Check if the 'suffix' slot has content
      return !!this.$slots["suffix"];
    },
    hasPrefixContent() {
      // Check if the 'prefix' slot has content
      return this.preIcon === true ? true : !!this.$slots["prefix"];
    },
  },
  beforeMount() {
    if (this.required) {
      this.validationRules.push({
        required: true,
        message: this.requiredMessage ? this.requiredMessage : "Obrigatório",
      });
    }
  },
};
</script>

<style lang="sass">
.hf-input-wrapper
  .ant-form-explain
    font-size: 9px !important
    top: -4px
    position: relative

.hf-input.ant-input-affix-wrapper
  .ant-input
    border: 2px solid #d9d9d9
    border-radius: 0
    border-width: 0 0 2px 0
    padding-left: 21px
    &:focus
      border-right-width: 0
      outline: 0
      box-shadow: none

  .ant-input-prefix
    left: 0
</style>

<style lang="sass" scoped>
.hf-wrapper
  label
    font-size: 10px
    font-weight: 500
    color: #ccc
    line-height: 1
    text-overflow: ellipsis
    width: 100%
    white-space: nowrap
    margin-top: -10px
    margin-bottom: 2px
    display: block
  .hf-input.ant-input-affix-wrapper
    border: 0
  .hf-input
    border: 2px solid #d9d9d9
    border-radius: 0
    border-width: 0 0 2px 0
    padding-left: 0
    &:focus
      border-right-width: 0
      outline: 0
      box-shadow: none
  .description
    font-size: 9px
    line-height: 1.2
    margin: 8px  0 3px
    font-weight: 500
    border-left: 2px solid #ddd
    padding-left: 7px
</style>
